import React from "react";
import settings, { LPPOLICE, ENTERSECT } from "../../settings";

const getLppoliceContact = () => (
  <span>
    <h4 className="font-family">Free Customer Support: 1-877-482-0101</h4>
    <p className="font-family contact-sub-line">Monday through Friday</p>
    <p className="font-family contact-sub-line">8:30 AM to 5 PM ET</p>
    <p className="font-family contact-sub-line">customerservice@lppolice.com</p>
  </span>
);
const getEntersectContact = () => (
  <span>
    <h4 className="font-family">Free Customer Support: 1-877-482-0101</h4>
    <p className="font-family contact-sub-line">Monday through Friday</p>
    <p className="font-family contact-sub-line">8:30 AM to 5 PM ET</p>
    <p className="font-family contact-sub-line">
      customerservice@entersect.net
    </p>
  </span>
);
const getLocateplusContact = () => (
  <span>
    <h4 className="font-family">Free Customer Support: 1-888-746-3463</h4>
    <p className="font-family contact-sub-line">Monday through Friday</p>
    <p className="font-family contact-sub-line">8:30 AM to 5 PM ET</p>
    <p className="font-family contact-sub-line">
      customerservice@locateplus.com
    </p>
  </span>
);

export const getContact = () => {
  switch (settings.appName) {
    case LPPOLICE:
      return getLppoliceContact();
    case ENTERSECT:
      return getEntersectContact();
    default:
      return getLocateplusContact();
  }
};

export default getContact;



// WEBPACK FOOTER //
// ./src/components/navigation/Contact.js